import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PageLoaderService } from '@aston/foundation';

import { AuthenticationService } from '../services';

@Injectable({
	providedIn: 'root'
})
export class AnonymousGuard implements CanActivate {
	private authenticationService = inject(AuthenticationService);
	private pageLoaderService = inject(PageLoaderService);


	canActivate(): Observable<boolean> | boolean {
		return this.isAuthenticated();
	}

	canLoad(): Observable<boolean> | boolean {
		return this.isAuthenticated();
	}

	private isAuthenticated(): Observable<boolean> | boolean {
		this.pageLoaderService.start();

		return this.authenticationService.getIsAuthenticated().pipe(
			map((isAuthorized: boolean) => {
				this.pageLoaderService.end();

				if (! isAuthorized) {
					return true;
				}

				return false;
			})
		);
	}
}
